import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { environment } from '../environments/environment';

export interface Rates {
  silverPerGram: number;
  gstPercent: number;
}

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl + '/config';

  private silverRate$ = new BehaviorSubject<number>(105);
  silverRate = this.silverRate$.asObservable();

  getRates(): Observable<Rates> {
    return this.http.get<Rates>(`${this.apiUrl}/rates`).pipe(
      tap(rates => this.silverRate$.next(rates.silverPerGram))
    );
  }

  updateSilverRate(silverPerGram: number): Observable<{ silverPerGram: number }> {
    return this.http.put<{ silverPerGram: number }>(`${this.apiUrl}/rates`, { silverPerGram }).pipe(
      tap(res => this.silverRate$.next(res.silverPerGram))
    );
  }

  get currentSilverRate(): number {
    return this.silverRate$.getValue();
  }

  calculatePrice(product: any, silverRate: number): { strikePrice: number; salePrice: number; savings: number } {
    let strikePrice = 0;
    if (product.pricingType === 'perGram') {
      const metalCost = (product.weightInGrams || 0) * silverRate;
      const makingCost = product.makingChargesType === 'percent'
        ? metalCost * ((product.makingCharges || 0) / 100)
        : (product.makingCharges || 0);
      strikePrice = metalCost + (product.stoneCharges || 0) + (product.otherCharges || 0) + makingCost;
    } else {
      strikePrice = product.basePrice || 0;
    }
    const gross = Math.round(strikePrice);
    const rawDiscount = product.discountType === 'flat'
      ? (product.discountAmount || 0)
      : gross * (product.discountPercent || 0) / 100;
    const savings = Math.min(gross, Math.round(rawDiscount));   // never exceed gross
    return { strikePrice: gross, salePrice: gross - savings, savings };
  }
}
